import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentgatewayService {

  
  private apiUrl = 'http://localhost:8000/create-payment'; // Replace with the actual endpoint

  constructor(private http: HttpClient) { }

  createPayment(): Observable<any> {
    // Here you might pass any required parameters for payment creation
    return this.http.post(this.apiUrl, {});
  }

  proceedToPay(customerInfo: any): Observable<any> {
    return this.http.post(this.apiUrl, customerInfo);
  }
}
